export default "__VITE_ASSET__Dw610M2v__"